import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get } from "../../utils/axios-config";
import { NAVIGATION_LOGS } from "../../utils/constants";

export const getNavigationLogs = async (filters?: PagedRequestType) => {
    const params = new URLSearchParams();

    if (filters?.searchTerm) params.append("searchTerm", filters.searchTerm);
    if (filters?.type) params.append("type", filters.type);
    if (filters?.userId) params.append("userId", filters.userId);
    if (filters?.date) params.append("date", filters.date);
    const url = `${NAVIGATION_LOGS}?${params.toString()}`;
    return await get<PagedResultsType<any>>(url);
};